<template>
  <BaseLoader v-if="loading" />
  <div v-else id="payment-status" class="payment-success splash">
    <img src="@/asset/icon/card-approved.svg" alt="">
    <h1>{{ $t('balance.thank_you_for_your_payment') }}</h1>
    <h2>{{ $t('balance.your_money_will_arrive_soon') }}</h2>
    <div class="content">
      <p>{{ $t('balance.your_payment_is_still_processing') }}</p>
      <p>{{ $t('balance.in_case_you_do_not_receive') }}</p>
    </div>
    <BamLink class="btn btn-primary" :to="ROUTE.wallet">
      {{ $t('balance.back_to_wallet') }}
    </BamLink>
  </div>
</template>

<script setup>
import { ROUTE } from '@/facade/enum.js';
import { BamLink } from 'bambam-router';
import { onMounted, ref } from 'vue';
import { buyCartInStorage } from '@/hook/market/cart.js';
import BaseLoader from '@/component/body/BaseLoader.vue';

const loading = ref(true);

onMounted(async () => {
  loading.value = await buyCartInStorage();
});
</script>
